import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { CheckSensitiveWords } from '@/infrastructure/api-functions/core-drafting-api/check-sensitive-words-api';
import { CheckSensitiveWordService } from '../check-sensitive-word';

@injectable()
export class CheckSensitiveWordServiceImpl implements CheckSensitiveWordService {
    constructor(
        @inject(CheckSensitiveWords)
        private readonly _checkSensitiveWordsApi: CheckSensitiveWords,
    ) {
    }

    public async checkSensitiveWord(text: string): Promise<string> {
        if (!text) return Promise.resolve('');
        return this._checkSensitiveWordsApi.checkSensitiveWords({ content: text });
    }
}
